import React, { useContext, useEffect, useState } from 'react';
import styles from './CampaignLaunch.module.css';
import { Link } from 'react-router-dom'
import { BASE_URL_API } from '../../../References/URLs';
import AuthContext from '../../../store/auth-context';
import ActiveStoreContext from '../../../store/ActiveStoreContext';
import useUnloadWarning from './../../../Helper/useUnloadWarning';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import CampaignCostCalculator from './CampaignCostCalculator';

const CampaignLaunch = ({ data, setData }) => {
    const [isFormDirty, setIsFormDirty] = useState(true);
    useUnloadWarning(isFormDirty)
    const { campaignIdentifier } = useParams()
    const authCtx = useContext(AuthContext);
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const [isCurrentlyLaunching, setIsCurrentlyLaunching] = useState(false)
    const nav = useNavigate()
    const [templateName, setTemplateName] = useState('valentines_week_special_get_a_voucher');
    const [audienceData, setAudienceData] = useState([
        {
            "phoneNumber": "9319408406",
            "clientStoreRelationIdentifier": "201655614158001803WALKIN167878453820230318",
            "storeIdentifier": "201655614158001803",
            "clientName": "Nav",
            "gender": "Female"
        },
        {
            "phoneNumber": "9999648406",
            "clientStoreRelationIdentifier": "201655614158001803WALKIN167878453820230318",
            "storeIdentifier": "201655614158001803",
            "clientName": "Nav",
            "gender": "Female"
        },
        {
            "phoneNumber": "8448191903",
            "clientStoreRelationIdentifier": "201655614158001803WALKIN167878453820230318",
            "storeIdentifier": "201655614158001803",
            "clientName": "Nav",
            "gender": "Female"
        },
        // {
        //     "phoneNumber": "8958120679",
        //     "clientStoreRelationIdentifier": "201655614158001803WALKIN167878453820230318",
        //     "storeIdentifier": "201655614158001803",
        //     "clientName": "Nav",
        //     "gender": "Female"
        // },
    ]);
    const [analysisData, setAnalysisData] = useState({});
    const [walletBalance, setWalletBalance] = useState(0)
    const [isPaymentRequired, setIsPaymentRequired] = useState(false)
    const [amountRequired, setAmountRequired] = useState(1)
    const [isLoadingWalletBalance, setIsLoadingWalletBalance] = useState(false)

    useEffect(() => {
        if (data?.audience && data.audience.audienceData) {
            setAudienceData(data.audience.audienceData);
        }
    }, [data]);

    useEffect(() => {
        setAmountRequired(Math.ceil(parseFloat(parseFloat(parseFloat(audienceData?.length * 0.76) * 1.02) * 1.18).toFixed(2)))
    }, [])
    

    const getStoreWalletBalance = async () => {
        setIsLoadingWalletBalance(true)
        const response = await fetch(BASE_URL_API + "getStoreWalletBalance",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setWalletBalance(respo?.currentBalance)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
                setWalletBalance(0)
                console.log(respo)
            }
        }
        setIsLoadingWalletBalance(false)
    }

    const deductWalletBalance = async () => {
        const response = await fetch(BASE_URL_API + "deductWalletBalance",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    campaignIdentifier : campaignIdentifier,
                    vendorIdentifier : vendorIdentifier,
                    storeIdentifier: activeStore?.storeIdentifier,
                    amount : parseFloat(parseFloat(parseFloat(audienceData?.length * 0.76) * 1.03) * 1.18).toFixed(2)
                })
            })

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                getStoreWalletBalance()
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
            console.log(respo)
        }
    }


    // Helper function to divide data into batches of a specified size
    const chunkArray = (arr, size) => {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    };

    // Function to send messages in batches
    const sendBatch = async (batch, template) => {
        const startTime = Date.now(); // Start time for this batch
        const response = await fetch(BASE_URL_API + "sendPromoComViaWaBulk", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                phoneNumberData: batch,
                campaignIdentifier: campaignIdentifier,
                templateName: data?.templateName,
                templateIdentifier: data?.templateIdentifier
            })
        });

        const endTime = Date.now(); // End time for this batch
        const executionTime = endTime - startTime; // Calculate time taken for this batch

        if (!response.ok) {
            console.error("Server error in batch request.");
            return {
                batchData: batch.map(item => ({ ...item, status: "Failed" })),
                executionTime,
                serverErrorCount: 1,
            };
        } else {
            const data = await response.json();
            const batchData = data?.response.map((item, idx) => ({
                ...batch[idx],
                status: item.status === "success" ? "Sent" : "Failed",
                responseData: item.response || {}
            }));

            const successfullySent = batchData.filter(item => item.status === "Sent").length;
            const failedSent = batchData.filter(item => item.status === "Failed").length;

            return {
                batchData,
                executionTime,
                successfullySent,
                failedSent,
                serverErrorCount: 0,
            };
        }
    };

    // Function to analyze and log batch processing statistics
    const analyzeBatchProcess = (batches, batchResults, startTime) => {
        const totalExecutionTime = Date.now() - startTime;
        const totalBatches = batches.length;
        const totalData = audienceData.length;

        const successfullySent = batchResults.reduce((acc, res) => acc + res.successfullySent, 0);
        const failedSent = batchResults.reduce((acc, res) => acc + res.failedSent, 0);
        const serverErrorCount = batchResults.reduce((acc, res) => acc + res.serverErrorCount, 0);

        const averageBatchTime = batchResults.reduce((acc, res) => acc + res.executionTime, 0) / totalBatches;

        setAnalysisData({
            totalData,
            totalBatches,
            totalExecutionTime,
            successfullySent,
            failedSent,
            serverErrorCount,
            averageBatchTime,
        });

        console.log("Batch Analysis:", {
            totalData,
            totalBatches,
            totalExecutionTime,
            successfullySent,
            failedSent,
            serverErrorCount,
            averageBatchTime,
        });
    };

    // Function to handle the entire audience data in batches
    const sendAllPromoComViaWa = async () => {
        if (campaignIdentifier && campaignIdentifier.trim() !== "") {
            if (data?.templateName && data?.templateName?.trim() !== '') {
                // let's calculate balance
                if (audienceData?.length < 1) {
                    return
                }
                let amtReq = Math.ceil(parseFloat(parseFloat(parseFloat(audienceData?.length * 0.76) * 1.02) * 1.18).toFixed(2))
                setAmountRequired(amtReq)
                if (amtReq > walletBalance) {
                    setIsPaymentRequired(true)
                    setIsFormDirty(false)
                    return;
                } else {
                    setIsPaymentRequired(false)
                }
                console.log(amtReq, walletBalance)

                setIsCurrentlyLaunching(true)
                const startTime = Date.now();
                const batches = chunkArray(audienceData, 30);
                const batchResults = [];

                for (const batch of batches) {
                    const result = await sendBatch(batch, templateName);
                    batchResults.push(result);

                    // Update the status in audienceData in real time
                    setAudienceData(prevData =>
                        prevData.map(item =>
                            result.batchData.find(res => res.phoneNumber === item.phoneNumber) || item
                        )
                    );
                }
                setIsCurrentlyLaunching(false)
                // Analyze the batch process once all batches are completed
                analyzeBatchProcess(batches, batchResults, startTime);
                deductWalletBalance()
                toast(`Campaign completed!`)

            } else {
                alert(`You must select a template!`)
                console.log(templateName)
                nav(`/communications/campaign/${campaignIdentifier}/templates`)
            }
        } else {
            alert(`Campaign Identifier can't be blank!`)
        }
    };

    useEffect(() => {
        getStoreWalletBalance()
    }, [])
    

    console.log(analysisData);

    return (
        <div className={styles.container}>
            {isPaymentRequired && <CampaignCostCalculator isOpen={isPaymentRequired} amountRequired={amountRequired} onClose={() => setIsPaymentRequired(false)} />}
            <div className={styles.launchHeader}>
                <div>
                    <div>Launch Campaign</div>
                    <div className={styles.subtitle} >Are you ready to launch your campaign?</div>
                    <div>
                        {data?.templateName}
                    </div>
                </div>

                <div className={styles.launch} >
                    <div>
                        <div className={styles.availableTxt} >
                            Available Balance
                        </div>
                        <div>
                            ₹{walletBalance}
                        </div>
                    </div>
                    {isCurrentlyLaunching === true ?
                        <button disabled>Being Launched...</button>
                        :
                        <button onClick={() => sendAllPromoComViaWa()}>Launch Now</button>
                    }
                </div>
            </div>
            <div className={styles.launchBody}>
                <div className={styles.launchBodyContainer}>
                    <div className={styles.dataTableWrapper}>
                        <div className={styles.listWrapper}>
                        <div className={`${styles.eachRow} ${styles.tableHeader}`}>
                                <div className={styles.sn}>#</div>
                                <div className={styles.clientName}>Client </div>
                                <div className={styles.phoneNumber}>Phone</div>
                                <div className={styles.gender}>Gender</div>
                                <div className={styles.status} >Status</div>
                            </div>
                            {audienceData?.map((item, index) => (
                                <div className={styles.eachRow} key={index}>
                                    <div className={styles.sn}>{index + 1}.</div>
                                    <div className={styles.clientName}>{item?.clientName}</div>
                                    <div className={styles.phoneNumber}>{item?.phoneNumber}</div>
                                    <div className={styles.gender}>{item?.gender}</div>
                                    <div className={styles.status} >{item?.status || "Pending"}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className={styles.analysisWrapper}>
                        <h3>Analysis Data</h3>
                        <pre>{JSON.stringify(analysisData, null, 2)}</pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignLaunch;
